import { useEffect } from "react";
import { useNotification } from "../notificationProvider";
import { registerNotify } from "../../utils/notifyOnPage";

export default function SocketNotification() {
  const notify = useNotification();
  useEffect(() => {
    registerNotify(notify);
  }, [notify]);

  return null;
}
